import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface RemoteTeacherUpsertState extends ApiState {
  teacherId?: string
}

export default requestReducer<RemoteTeacherUpsertState>('REMOTE_TEACHER_UPSERT')
